import { useUrlParams } from "src/global/utils/urlParams.ts"
import { DqiValue } from "src/pages/DataHealthDashboard/constants"

export const useDqiFilter = () => {
  const [{ dqi }, setUrlParams] = useUrlParams({ dqi: "overall" as DqiValue })

  return {
    dqi,
    gqlDQI: dqi === "overall" ? undefined : dqi.toUpperCase(),
    setDqi: (value: DqiValue) => setUrlParams({ dqi: value }),
  }
}
